import { api } from "../../services";
import { $config } from "../../conf";
import $store from "../../store";

export let webinarAPI = {
  /**
   * 获取指定的线上会报名者信息
   * @param webinarId 会议id
   * @returns {*}
   */
  onWebinarContactsGet({ webinarId }) {
    return api.request("/api/webinar/contacts/get", {
      tenantId: $config.tenantId,
      sess: $store.state.userInfo.session,
      webinarId,
    });
  },
};
